import * as api from "../api/auth";
import { LOAD_USER_SUCCESS, LOGOUT_USER, loadUser } from "./user";
import { START_PROGRESS, STOP_PROGRESS } from "./progress";
import { showNotification } from "./notification";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const CHECK_AUTH_STATUS = "CHECK_AUTH_STATUS";

export const login = (email, password) => async (dispatch) => {
  try {
    dispatch({ type: START_PROGRESS });
    const { data } = await api.login(email, password);
    dispatch({ type: LOGIN_SUCCESS, payload: { token: data.accessToken } });
    dispatch({ type: LOAD_USER_SUCCESS, payload: data.user });
    dispatch(
      showNotification({
        message: data?.message || "Login realizado com sucesso.",
        color: data?.type || "success",
      })
    );
  } catch (error) {
    const errorMessage = error?.message || "Erro ao fazer login. Tente novamente.";
    dispatch({ type: LOGIN_FAIL, payload: errorMessage });
    dispatch(
      showNotification({
        message: errorMessage,
        color: error?.type || "failure",
      })
    );
  } finally {
    dispatch({ type: STOP_PROGRESS });
  }
};

export const logout = () => async (dispatch) => {
  try {
    dispatch({ type: START_PROGRESS });
    const { data } = await api.logout();
    dispatch({ type: LOGOUT });
    dispatch({ type: LOGOUT_USER });
    dispatch(
      showNotification({
        message: data?.message || "Logout realizado com sucesso.",
        color: data?.type || "info",
      })
    );
  } catch (error) {
    console.error("Logout Error: ", error);
    dispatch(
      showNotification({
        message: error?.message || "Erro ao realizar logout.",
        color: error?.type || "failure",
      })
    );
  } finally {
    dispatch({ type: STOP_PROGRESS });
  }
};

export const checkAuthStatus = () => async (dispatch) => {
  try {
    dispatch({ type: START_PROGRESS });
    const { data } = await api.checkAuthStatus();
    dispatch({
      type: CHECK_AUTH_STATUS,
      payload: { authenticated: data.authenticated },
    });

    if (data.authenticated) {
      await dispatch(loadUser());
    }
  } catch (error) {
    console.error("Check Auth Status Error: ", error);
    dispatch({
      type: CHECK_AUTH_STATUS,
      payload: { authenticated: false },
    });
  } finally {
    dispatch({ type: STOP_PROGRESS });
  }
};
